import { CitationSourceEnum } from '../types';

export const CITATION_EXPORT_CONTROL_HEIGHT = 48;
export const CITATION_SELECT_HEIGHT = 100;

export const citationSourceLabels: {
  [key in CitationSourceEnum]: {
    label: string;
  };
} = {
  Website: {
    label: 'Website',
  },
  Book: {
    label: 'Book',
  },
  Journal: {
    label: 'Journal Article',
  },
};
